import React from 'react';
import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  resolve: () => import(
    /* webpackChunkName: "trustpilot" */
    /* webpackPreload: true */
    './index.js'
  ),
  LoadingComponent: () => <s />,
  serverMode: 'defer'
});
